var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`cq_icon ${_vm._class}`,on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('i',{class:'risen cq-' + _vm.name,style:({ color: _vm.color, width: _vm._iconSize, height: _vm._iconSize, fontSize: _vm._iconSize })})])
}
var staticRenderFns = []

export { render, staticRenderFns }